import React, { useEffect, useState } from 'react';
import _ from 'lodash';

import { useNotifications } from 'hooks';
import { makeStyles } from '@material-ui/styles';

import { Alert, AlertTitle } from '@material-ui/lab';
import { Collapse, Button } from '@material-ui/core';
const useStyles = makeStyles(() => ({
  positioning: {
    position: 'fixed',
    bottom: 50,
    right: 30,
    width: '20%',
    minWidth: 250,
    overflow: 'auto',
    maxHeight: 300,
    '&::-webkit-scrollbar': {
      display: 'none',
    },
  },
  eachAlert: {
    marginTop: 10,
  },
  buttonsStyling: { minWidth: 130 },
}));

const UserNotification = () => {
  const classes = useStyles();

  const { clearSingleNotification, clearAllNotificationsBySeverity, getAllNotifications, getNotificationsLength } =
    useNotifications();
  const [notificationsOpen, setNotificationsOpen] = useState([]);
  const [notifications, setNotifications] = useState([]);

  useEffect(() => {
    if (notificationsOpen !== undefined && notificationsOpen.length > 0) {
      createNotificationUI();
    }
  }, [notificationsOpen]);

  useEffect(() => {
    const tempNotifications = [...getAllNotifications.notifications];
    setNotificationsOpen(tempNotifications);
  }, [getNotificationsLength]);

  const closeNotification = (value) => {
    clearSingleNotification(value.key);
  };

  const closeAllOfTypeNotification = (value) => {
    clearAllNotificationsBySeverity(value);
  };

  const createNotificationUI = () => {
    let addingAlerts = [];
    _.forEach(notificationsOpen, (value) => {
      const individualAlert = (
        <Collapse in={true} key={value.key} className={classes.eachAlert}>
          <Alert
            variant={value.severity === 'error' ? 'filled' : 'standard'}
            severity={value.severity}
            action={
              <div className={classes.buttonsStyling}>
                <Button
                  color="inherit"
                  size="small"
                  onClick={() => {
                    closeNotification(value);
                  }}
                >
                  CLEAR
                </Button>
                <Button
                  color="inherit"
                  size="small"
                  onClick={() => {
                    closeAllOfTypeNotification(value.severity);
                  }}
                >
                  CLEAR ALL
                </Button>
              </div>
            }
          >
            <AlertTitle>{value.title}</AlertTitle>
            {value.message}
          </Alert>
        </Collapse>
      );
      addingAlerts = [...addingAlerts, individualAlert];
    });

    setNotifications(addingAlerts);
  };

  return (
    notificationsOpen !== undefined &&
    notificationsOpen.length > 0 && <div className={classes.positioning}>{notifications}</div>
  );
};

export default UserNotification;
